module.exports = __webpack_public_path__ + "images/fc-footer-top.png";